import ProductFormHandler from '../qf/productFormHandler.js';

// init the handler when DOM is ready for the main product page
document.addEventListener('DOMContentLoaded', () => {
  // Initialize for the main product page (passing document as the container)
  const productForm = new ProductFormHandler(document);
});